module.exports = __webpack_public_path__ + "img/staff-p-1080.0de3de16.png";